import requests from "../agent";

const Embarque = {
    getEmbarqueById: (idEmbarque) => requests.get(`/Embarque/GetEmbarqueById/${idEmbarque}`),
    getEmbarques: (data) => requests.post(`/Embarque/GetEmbarques`, data),
    leerAlertasUsuario: (data) => requests.post(`/Embarque/LeerAlertasUsuario`, data),
    cerrarAlertasUsuario: (data) => requests.post(`/Embarque/CerrarAlertasUsuario`, data),
    crearEmbarque: (data) => requests.post(`/Embarque/CrearEmbarque`, data),
    editarEmbarque: (idEmbarque, data) => requests.put(`/Embarque/EditarEmbarque/${idEmbarque}`, data),
    getEmbarqueFile: (idEmbarque) => requests.postFileBlob(`/Embarque/GetEmbarqueFile/${idEmbarque}`, null),
    exporterExcel: (filter, name) => requests.download("/Embarque/ExporterByFilter", name, filter),
    bloquearEmbarque: (idEmbarque, esEditar) => requests.patch(`/Embarque/BloquearEmbarque/${idEmbarque}/${esEditar}`, null),
    desbloquearEmbarque: (idEmbarque) => requests.patch(`/Embarque/DesbloquearEmbarque/${idEmbarque}`, null),
    actualizarEstatusEmbarque: (idEmbarque, model) => requests.patch(`/Embarque/ActualizarEstatusEmbarque/${idEmbarque}`, model),
    consultarComprobanteArchivo: (idEmbarque) => requests.showFileNewWindow("/Embarque/ConsultarComprobanteArchivo/" + idEmbarque),
    consultarComprobanteArchivoFile: (idEmbarque) => requests.getFileBlob("/Embarque/ConsultarComprobanteArchivo/" + idEmbarque),
};

export default Embarque;
